import { Button, Collapse, Fade, Grid, Typography } from "@material-ui/core";
import { imgLogoLogin, imgLogoMeditocCasa } from "../../settings/imgConfig";

import MeditocInputWhite from "../utils/MeditocInputWhite";
import MeditocPassword from "../utils/MeditocPassword";
import { inputVariant } from "../../settings/inputConfig";
import { useLogin } from "../../context/LoginContext";
import { useStyle } from "../../context/StyleContext";

export default function MeditocLogin() {
    const { classes } = useStyle();
    const {
        formLogin,
        formRecuperar,
        openFormRecuperar,
        openFormEnvioCorreo,
        ConfirmacionExitosa,
        openPortadaLogin,
        mostrarPassword,
        lngConfirmCorreo,
        handleToggleFormRecuperar,
        handleChangeMostrarPassword,
        handleChangeFormLogin,
        handleChangeFormRecuperar,
        handleSubmitLogin,
        handleSubmitRecuperar,
    } = useLogin();

    const { txtUsuarioMeditoc, txtPasswordMeditoc } = formLogin;
    const { txtRecuperarMeditoc } = formRecuperar;

    return (
        <div className="login-container">
            <Grid container spacing={0} className="login-page">
                <Grid item md={8} xs={12} className="align-self-center">
                    <div className="login-logo-container">
                        <Fade in={openPortadaLogin} timeout={1500}>
                            <img src={imgLogoLogin} alt="LOGOLOGIN" className="login-logo-img" />
                        </Fade>
                    </div>
                </Grid>
                {openFormEnvioCorreo && (
                    <Grid item md={4} xs={12} className="login-form-back">
                        <div>
                            <Collapse in={!openFormRecuperar}>
                                <form className="login-form-container" onSubmit={handleSubmitRecuperar} noValidate>
                                    <Grid container spacing={4}>
                                        <Grid item xs={12}>
                                            {ConfirmacionExitosa == null && (
                                                <span className="ops-nor bold size-25">
                                                    {lngConfirmCorreo === "es"
                                                        ? "Estamos validando tu confirmación"
                                                        : "We are validating your confirmation"}
                                                </span>
                                            )}
                                            {ConfirmacionExitosa == true && (
                                                <span className="ops-nor bold size-25">
                                                    {lngConfirmCorreo === "es"
                                                        ? "¡Bienvenido a tu cuenta Meditoc!"
                                                        : "¡Welcome to your Meditoc account!"}
                                                </span>
                                            )}
                                            {ConfirmacionExitosa == false && (
                                                <span className="ops-nor bold size-25">
                                                    {lngConfirmCorreo === "es"
                                                        ? "Lo sentimos no pudimos encontrar tu cuenta para activarla"
                                                        : "Sorry we couldn't find your account to activate it"}
                                                </span>
                                            )}
                                        </Grid>
                                        {ConfirmacionExitosa == true && (
                                            <Grid item xs={12}>
                                                <Typography>
                                                    {lngConfirmCorreo === "es"
                                                        ? "Tu cuenta Meditoc ha sido activada ya podrás utilizar la aplicación móvil."
                                                        : "Your Meditoc account has been activated and you can use the mobile application."}
                                                </Typography>
                                            </Grid>
                                        )}
                                    </Grid>
                                </form>
                            </Collapse>
                        </div>
                    </Grid>
                )}
                {!openFormEnvioCorreo && (
                    <Grid item md={4} xs={12} className="login-form-back">
                        <div>
                            <Collapse in={!openFormRecuperar}>
                                <form className="login-form-container" onSubmit={handleSubmitLogin} noValidate>
                                    <Grid container spacing={4}>
                                        <Grid item xs={12}>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <span className="ops-nor bold size-25">INICIAR SESIÓN</span>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <MeditocInputWhite
                                                name="txtUsuarioMeditoc"
                                                label={txtUsuarioMeditoc.label}
                                                value={txtUsuarioMeditoc.value}
                                                required={txtUsuarioMeditoc.required}
                                                onChange={handleChangeFormLogin}
                                                variant={inputVariant}
                                                fullWidth
                                                autoFocus
                                                autoComplete="off"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <MeditocInputWhite
                                                name="txtPasswordMeditoc"
                                                label={txtPasswordMeditoc.label}
                                                value={txtPasswordMeditoc.value}
                                                required={txtPasswordMeditoc.required}
                                                onChange={handleChangeFormLogin}
                                                variant={inputVariant}
                                                fullWidth
                                                autoComplete="new-password"
                                                type={mostrarPassword ? "text" : "password"}
                                                InputProps={{
                                                    endAdornment: (
                                                        <MeditocPassword
                                                            view={mostrarPassword}
                                                            setView={handleChangeMostrarPassword}
                                                            white
                                                        />
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button
                                                variant="contained"
                                                type="submit"
                                                className={classes.button}
                                                fullWidth
                                            >
                                                ENTRAR
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button
                                                variant="text"
                                                color="inherit"
                                                type="button"
                                                fullWidth
                                                onClick={() => handleToggleFormRecuperar(true)}
                                            >
                                                ¿Olvidaste tus credenciales?
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12}>
                                            {" "}
                                        </Grid>
                                    </Grid>
                                </form>
                            </Collapse>
                            <Collapse in={openFormRecuperar}>
                                <form className="login-form-container" onSubmit={handleSubmitRecuperar} noValidate>
                                    <Grid container spacing={4}>
                                        <Grid item xs={12}>
                                            <span className="ops-nor bold size-25">RECUPERAR ACCESO</span>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography>
                                                Para recuperar sus credenciales de acceso ingrese el correo electrónico
                                                registrado en el sistema.
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <MeditocInputWhite
                                                name="txtRecuperarMeditoc"
                                                label={txtRecuperarMeditoc.label}
                                                value={txtRecuperarMeditoc.value}
                                                required={txtRecuperarMeditoc.required}
                                                onChange={handleChangeFormRecuperar}
                                                variant={inputVariant}
                                                fullWidth
                                                autoComplete="off"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button
                                                variant="contained"
                                                type="submit"
                                                className={classes.button}
                                                fullWidth
                                            >
                                                Enviar credenciales
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button
                                                variant="text"
                                                color="inherit"
                                                type="button"
                                                fullWidth
                                                onClick={() => handleToggleFormRecuperar(false)}
                                            >
                                                Regresar al Login
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </Collapse>
                        </div>
                    </Grid>
                )}
            </Grid>
        </div>
    );
}
